import type { BffApiClient } from "@/app/api-client"
import { NotFoundError } from "@/app/sdk/errors"
import type { InferRequestType } from "hono"

export type QueryInput = InferRequestType<
  BffApiClient["api"]["nfts"][":id"]["$get"]
>["param"]

export const getNftQueryParams = (
  apiClient: BffApiClient,
  queryInput: QueryInput,
) => ({
  queryKey: ["nft", queryInput],
  queryFn: async () => {
    const response = await apiClient.api.nfts[":id"].$get({
      param: queryInput,
    })

    if (!response.ok) {
      const error = await response.json()
      if (response.status === 404) {
        return Promise.reject(new NotFoundError("NFT not found"))
      }
      return Promise.reject(error)
    }

    return response.json()
  },
})

type QueryFn = ReturnType<typeof getNftQueryParams>["queryFn"]

export type QueryResponse = Awaited<ReturnType<QueryFn>>
